import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
import wujiFetch from '@/utils/wujiFetch';
import { useRouter } from '@/router/useRouter';
const getProjectId = () => useRouter()?.route?.value?.query?.projectid;
// 将通用的http请求函数统一为wujiFetch，保持与项目其他部分一致
const http = async (url, options = {}) => {
    const response = await wujiFetch(url, options);
    return response;
};
const getApiBase = () => `${getXyManagePathPrefix()}/ai-project`;
export const projectAPI = {
    async initializeProject() {
        await http(`${getApiBase()}/initialize?projectId=${getProjectId()}`, {
            method: 'POST',
        });
        return true;
    },
    async getProjectInfo() {
        const data = await http(`${getApiBase()}/info?projectId=${getProjectId()}`, {
            method: 'GET',
        });
        return data;
    },
    async updateProjectInfo(projectInfo) {
        await http(`${getApiBase()}/info?projectId=${getProjectId()}`, {
            method: 'POST',
            body: JSON.stringify(projectInfo),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return true;
    },
};
export const conversationAPI = {
    async listConversations() {
        const projectId = encodeURIComponent(getProjectId());
        const data = await http(`${getApiBase()}/conv?projectId=${projectId}`, {
            method: 'GET',
        });
        return Array.isArray(data) ? data : [];
    },
    async getConversation(conversationId) {
        const data = await http(`${getApiBase()}/conv/${encodeURIComponent(conversationId)}?projectId=${getProjectId()}`, {
            method: 'GET',
        });
        return data;
    },
    async upsertConversation(conversation) {
        let data = conversation;
        if ('messages' in conversation) {
            const copy = { ...conversation };
            delete copy.messages;
            data = copy;
        }
        await http(`${getApiBase()}/conv/${encodeURIComponent(conversation.id)}?projectId=${getProjectId()}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return true;
    },
    async upsertMessage(message) {
        await http(`${getApiBase()}/msg/${encodeURIComponent(message.id)}?projectId=${getProjectId()}`, {
            method: 'POST',
            body: JSON.stringify(message),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return true;
    },
    async batchUpsertMessages(messages) {
        await http(`${getApiBase()}/msg/batch?projectId=${getProjectId()}`, {
            method: 'POST',
            body: JSON.stringify(messages),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return true;
    },
};
export const repositoryAPI = {
    async listRepoObjects(mtime) {
        const query = new URLSearchParams();
        query.set('projectId', getProjectId());
        if (typeof mtime === 'number') {
            query.set('mtime', String(mtime));
        }
        const data = await http(`${getApiBase()}/repo/objects/list?${query.toString()}`, {
            method: 'GET',
        });
        return Array.isArray(data) ? data : [];
    },
    async readRepoObjects(oids) {
        const projectId = getProjectId();
        const data = await http(`${getApiBase()}/repo/objects/batch-read?projectId=${projectId}`, {
            method: 'POST',
            body: JSON.stringify(oids),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return data;
    },
    async writeRepoObjects(params) {
        await http(`${getApiBase()}/repo/objects/batch-write?projectId=${getProjectId()}`, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return true;
    },
    async readRepoRefs(mtime) {
        const query = new URLSearchParams();
        query.set('projectId', getProjectId());
        if (typeof mtime === 'number') {
            query.set('mtime', String(mtime));
        }
        const data = await http(`${getApiBase()}/repo/refs/list?${query.toString()}`, {
            method: 'GET',
        });
        return data;
    },
    async writeRepoRefs(params) {
        const updated = await http(`${getApiBase()}/repo/refs/batch-write?projectId=${getProjectId()}`, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return Array.isArray(updated) ? updated : [];
    },
};
const backendAPI = {
    conversationAPI,
    repositoryAPI,
    projectAPI,
};
export default backendAPI;
